import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Candidate } from 'src/app/models/candidate';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { UtilityService } from 'src/app/services/utility.service';
@Injectable({
  providedIn: 'root',
})
export class CandidateService {
  // Base url
  baseurl = environment.apiBase;
  constructor(private http: HttpClient, private utilityService: UtilityService) { }
  getAll(jobId: number) {
    if (jobId == 0) {
      return this.http.get<Candidate[]>(this.baseurl + `/jobmanagement/Candidates/`)
        .pipe(map(userroleroles => {
          return userroleroles;
        }));
    }
    else {
      return this.http.get<Candidate[]>(this.baseurl + `/jobmanagement/Candidates/GetByJob/` + jobId)
        .pipe(map(userroleroles => {
          return userroleroles;
        }));
    }
  }
  getById(id: number) {
    return this.http.get<Candidate>(this.baseurl + `/jobmanagement/Candidates/` + id);
  }
  // POST
  create(data: Candidate): Observable<Candidate> {
    return this.http
      .post<Candidate>(
        this.baseurl + '/jobmanagement/Candidates/',
        JSON.stringify(data)
      )
      .pipe(retry(1), catchError(this.utilityService.errorHandl));
  }
  update(data: Candidate, id: number): Observable<Candidate> {
    data.id = id;
    return this.http
      .put<Candidate>(
        this.baseurl + '/jobmanagement/Candidates/' + data.id,
        JSON.stringify(data)
      )
      .pipe(retry(1), catchError(this.utilityService.errorHandl));
  }
  delete(id: number) {
    return this.http
      .delete<Candidate>(
        this.baseurl + '/jobmanagement/Candidates/' + id
      )
      .pipe(retry(1), catchError(this.utilityService.errorHandl));
  }
}